// ------------------------------------
// FOTOS (CARROSSEL)
// ------------------------------------
$(function () {
  if ($(".produto-det-fotos").length) {
    const totalItens = $(".produto-det-foto").length;

    const cols = {
      desktop: 3,
      tablet: 2,
      mobile: 1,
    };

    // Carrossel principal
    const $carouselMain = $(".produto-det-fotos");
    let carouselMainOpts = {
      type: "loop",
      perPage: 3,
      perMove: 1,
      speed: 600,
      arrows: true,
      pagination: false,
      autoplay: true,
      breakpoints: {
        // Tablet
        1200: {
          type: "loop",
          perMove: 1,
          perPage: cols.tablet,
          speed: 600,
          arrows: true,
          pagination: true,
          autoplay: true,
        },
        // Mobile
        760: {
          type: "loop",
          perMove: 1,
          perPage: cols.mobile,
          speed: 600,
          arrows: true,
          pagination: true,
          autoplay: true,
        },
      },
    };
    if (totalItens === 1) {
      carouselMainOpts.type = "slide";
      carouselMainOpts.arrows = false;
      carouselMainOpts.pagination = false;
      carouselMainOpts.drag = false;
      carouselMainOpts.keyboard = false;
    }
    let carouselMain = new Splide($carouselMain[0], carouselMainOpts);

    carouselMain.mount();
  }
});

// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  "use strict";
  const enableZoom =
    $(".produto-det-fotos").data("zoom-hover") && $(window).width() > 960;
  if (enableZoom) {
    $(".produto-det-foto").each(function () {
      const $el = $(this);
      const imgLg = $(this).attr("href");
      if (imgLg) {
        $el.zoom({
          url: imgLg,
        });
      }
    });
  }
})();

// ------------------------------------
// Compartilhar Anuncio
// ------------------------------------
const anuncioShare = document.querySelector(".anuncio-share");
// Verifica se está na página do Anuncio
if (anuncioShare != null) {
  document
    .getElementById("anuncio-share")
    .addEventListener("click", function () {
      // 1. Pega o valor do atributo 'data-codigo' do elemento clicado
      // 'this' se refere ao elemento com o ID 'anuncio-share'
      const codigoAnuncio = this.getAttribute("data-codigo");

      // 2. Monta a URL base (URL atual da página)
      let url = window.location.href;

      // 3. Verifica se a URL já tem um '?' (parâmetros de query)
      // Se tiver, usa '&' para adicionar o novo parâmetro. Se não, usa '?'
      const separador = url.includes("?") ? "&" : "?";

      // 4. Concatena a URL com o código do anúncio como um parâmetro
      // Por exemplo: https://seusite.com/pagina?codigo=VALOR
      url = url + separador + "codigo=" + codigoAnuncio;

      // 5. Copia a nova URL
      navigator.clipboard
        .writeText(url)
        .then(() => {
          alert("Endereço copiado: " + url);
        })
        .catch((err) => {
          console.error("Erro ao copiar: ", err);
          alert("Houve um erro ao tentar copiar o endereço.");
        });
    });
}

const convertaMoeda = document.querySelector(".produto-det-valor");
// Verifica se está na página de detalhe do Anuncio
if (convertaMoeda != null) {
  (function ($) {
    var RATES = null; // { USD: 5.35, EUR: ..., GBP: ... }

    function formatCurrency(value, currencyCode) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: currencyCode,
        }).format(value);
      } catch (_) {
        // fallback simples
        return value.toFixed(2);
      }
    }

    // Recalcula conversão (BRL -> moeda escolhida)
    function recalcular() {
      $("#erro").hide().text("");
      var moeda = $("#moedaSelect").val();
      var valBRL = $(".produto-det-valor-por").data("valor");
      var valBRL2 = $(".produto-det-valor-de").data("valor");

      var taxa = Number(RATES[moeda]); // ex.: 5.35 significa 1 USD = 5,35 BRL
      var convertido = valBRL / taxa;
      var convertido2 = valBRL2 / taxa;

      $("#valor_convertido").text(formatCurrency(convertido, moeda));
      $("#valor_convertido2").text(formatCurrency(convertido2, moeda));
    }

    $(document).ready(function () {
      // Carrega as cotações uma única vez
      $.ajax({
        url: url_base + "acoes/api/cotacoes_api.php",
        method: "GET",
        dataType: "json",
        cache: false,
        beforeSend: function () {
          $("#erro").hide().text("");
          $("#info").hide();
        },
      })
        .done(function (resp) {
          if (!resp || !resp.success) {
            $("#erro")
              .text(
                resp && resp.message
                  ? resp.message
                  : "Falha ao carregar cotações."
              )
              .show();
            return;
          }
          RATES = resp.rates || null;
        })
        .fail(function () {
          $("#erro")
            .text("Erro de comunicação com o servidor de cotações.")
            .show();
        });

      // Dispara conversão ao mudar select e ao digitar valor
      $("#moedaSelect").on("change", recalcular);

      if ($("#moedaSelect").val()) {
        setTimeout(function () {
          recalcular();
        }, 1000); // delay de 1000ms = 1 segundo
      }
    });
  })(jQuery);
}
